// extracted by mini-css-extract-plugin
export default {"w-full":"Panel_w-full__r61qs","panel":"Panel_panel__0zCFp","avatar":"Panel_avatar__N0mzK","brand":"Panel_brand__5NUbW","share":"Panel_share__-dxyA","counter":"Panel_counter__XewFg"};